"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = void 0;
var _mui = require("@ori-ui/mui");
const Svg = exports.Svg = (0, _mui.styled)('svg')({
  maxHeight: '100%',
  maxWidth: '100%'
});
